
import assest from "../../json/assest";
import React from "react";
import styles1 from "../../styles/components/noResult.module.scss";
import styles from "../../styles/pages/user/CopywritePendingTitlingTable.module.scss";
import {
    AppBar,
    Box,
    Button,
    Dialog,
    Paper,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Typography,
} from "@mui/material";
import OopsIcon from "../../public/assets/icons/OopsIcon";




const NoResultTwo = (props) => {
    const { hideApprovedTab, approvedTabName, filterRowProps } = props;
    return (
        // <Box className={styles.table_sec}>
        //     {/* <Box className={styles.table_top}>
        //         <FilterRow
        //             {...filterRowProps}
        //             FilterModalComponent={AllPurchasedFilterModal}
        //             filterModalProps={{
        //                 hideBottom: true,
        //             }}
        //         />
        //     </Box> */}
        //     <Box className={styles.table_main}>

        // </Box>
        <>
            <Box className={`${styles1.emptyTable} ${styles.emptyTablecopywriter}`}>
                <Box className={styles1.emptyTableImg}>
                    <OopsIcon />
                </Box>
                <p>We couldn't find videos {props.heading} titling within the specified date range.</p>
            </Box>
        </>
    )
}

export default NoResultTwo